
import { TrainType } from "@/types";
import { computed, defineComponent, PropType, ref, watch } from "vue";
import rfdc from "rfdc";
import { useStore } from "@/store";
const clonedeep = rfdc();

export default defineComponent({
  props: {
    trainType: { type: Object as PropType<TrainType>, required: true },
    visible: { type: Boolean, required: true },
  },
  emits: ["update:trainType", "update:visible"],
  setup(props, context) {
    const store = useStore();
    const stationList = computed(() => store.state.stationList.stations);
    const stoppingStationList = ref<number[]>(
      clonedeep(props.trainType.stoppingStationList || [])
    );
    watch(
      () => props.trainType.stoppingStationList,
      (newList) => {
        stoppingStationList.value = newList;
      }
    );
    const localVisible = computed({
      get: () => props.visible,
      set: (value) => {
        context.emit("update:visible", value);
      },
    });
    const onClick = () => {
      const newTrainType = clonedeep(props.trainType);
      newTrainType.stoppingStationList = stoppingStationList.value;
      context.emit("update:trainType", newTrainType);
      localVisible.value = false;
    };
    const onHide = () => {
      stoppingStationList.value = clonedeep(
        props.trainType.stoppingStationList
      );
    };
    return {
      localVisible,
      stationList,
      stoppingStationList,
      onClick,
      onHide,
    };
  },
});
